import Application from "../../Application";
import { UserPreferences } from "../../core/common/Constants";
import { ILanguage } from "../../core/model/language/Language";
import { IStore } from "../../core/model/runtime/state/Store";
import { ILanguageService } from "../../core/service/language/LanguageService";
import { IStorageService } from "../../core/service/StorageService";
import GetOrganisationInteractor from "../../organisations/interactors/GetOrganisationInteractor";
import { IUserService } from "../../user/service/UserService";
import { ICredentialsService } from "../service/CredentialsService";

export default class LoadUserPreferencesInteractor {
  private application: Application;
  private credentialsService: ICredentialsService;
  private userService: IUserService;
  private getOrganisationInteractor: GetOrganisationInteractor;
  private languageService: ILanguageService;
  private storageService: IStorageService;

  private store: IStore;

  constructor({
    application,
    credentialsService,
    getOrganisation,
    userService,
    store,
    languageService,
    storageService
  }) {
    this.application = application;
    this.credentialsService = credentialsService;
    this.getOrganisationInteractor = getOrganisation;
    this.userService = userService;
    this.store = store;
    this.languageService = languageService;
    this.storageService = storageService;
  }
  async getCurrentLanguageCode() {
    const currentLanguage = await this.credentialsService.getLanguage();
    return String(currentLanguage);
  }

  async execute() {
    this.credentialsService.setIsLoggedIn(true);
    const user = await this.userService.getUserProfile();
    const languages = await this.languageService.getLanguages();
    let currentLanguageCode = await this.getCurrentLanguageCode();
    currentLanguageCode = currentLanguageCode
      ? currentLanguageCode
      : UserPreferences.DEFAULT_LANGUAGE;
    this.application.container.registerValue("language", currentLanguageCode);
    const selectedLanguage = languages.find(
      (langugage: ILanguage) => langugage.code === currentLanguageCode
    );

    const userOrganisation =
      user.organisationId != null
        ? await this.getOrganisationInteractor.execute(user.organisationId)
        : null;
    if (user.organisationId) {
      await this.storageService.save("organisationId", user.organisationId);
    }
    this.store.update({
      user,
      userOrganisation,
      languages,
      selectedLanguage,
      application: this.application
    });
  }
}
